import React, { useCallback, useContext, useEffect, useState } from "react";

import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";

import {
  Button,
  Dialog,
  DialogActions,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../context/Auth/AuthContext";

import html2pdf from "html2pdf.js";
import useDialogStyles from "../TransferTicketModalCustom/dialogStyles";

export default function TicketMessagesDialog({ open, handleClose, ticketId }) {
  const history = useHistory();
  const classes = useDialogStyles({ width: 400 });

  const { user, socket } = useContext(AuthContext);

  const [, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [contact, setContact] = useState({});
  const [ticket, setTicket] = useState({});

  const [exportedToPDF, setExportedToPDF] = useState(false);

  const handleExportToPDF = () => {
    const messagesListElement = document.getElementById("messagesList"); // Id do elemento que você deseja exportar para PDF
    const headerElement = document.getElementById("TicketHeader"); // Id do elemento de cabeçalho que você deseja exportar

    const pdfOPtions = {
      margin: 1,
      filename: `relatório_atendimento_${ticketId}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    if (messagesListElement) {
      const headerClone = headerElement.cloneNode(true);
      const messagesListClone = messagesListElement.cloneNode(true);

      const containerElement = document.createElement("div");
      containerElement.appendChild(headerClone); // Adicione o elemento do cabeçalho
      containerElement.appendChild(messagesListClone);
      html2pdf().from(containerElement).set(pdfOPtions).save();
    } else {
      toastError("Elemento não encontrado para exportar.");
    }
  };

  const handleExportAndClose = () => {
    if (!exportedToPDF) {
      handleExportToPDF();
      setExportedToPDF(true);
      handleClose(); // Fecha o Dialog
    }
  };

  useEffect(() => {
    if (open) {
      // Execute a exportação para PDF e feche o Dialog
      handleExportAndClose();
    }
  }, [open, ticketId, handleExportAndClose]);

  // Na prática este diálogo só aparece por um instante: ao abrir, exporta e fecha.
  return (
    <Dialog
      onClose={handleClose}
      open={open}
      classes={{ paper: classes.paper }}
      aria-labelledby="ticket-export-title"
    >
      <div className={classes.header}>
        <h2 id="ticket-export-title" className={classes.title}>
          Exportar conversa
        </h2>
        <p className={classes.subtitle}>
          O histórico deste atendimento é salvo em um arquivo PDF.
        </p>
      </div>
      <DialogActions className={classes.actions}>
        <Button onClick={handleClose} className={classes.cancel}>
          Fechar
        </Button>
        <Button
          onClick={handleExportToPDF}
          color="primary"
          variant="contained"
          className={classes.confirm}
        >
          Exportar para PDF
        </Button>
      </DialogActions>
    </Dialog>
  );
}
